import { IconUpload } from "@tabler/icons-react";
import { AnyCnameRecord } from "dns";
import React, { useRef, useState, useEffect } from "react";
import toast from "react-hot-toast";

type Props = {
  name?: string;
  onFileSelect?: (file: File) => void;
  initialFile?: string | File;
  register?: any;
  validation?: any;
  error?: any;
  accept?: string;
};

const CustomFileInput = ({
  name,
  onFileSelect,
  initialFile,
  register,
  validation,
  error,
  accept = "image/*, application/pdf",
}: Props) => {
  const fileRef = useRef<HTMLInputElement>(null);
  const [fileName, setFileName] = useState("No file chosen");

  useEffect(() => {
    if (initialFile instanceof File) {
      setFileName(initialFile.name);
    } else if (typeof initialFile === "string") {
      const parts = initialFile.split("/").pop()?.split("?")[0];
      setFileName(parts || "No file chosen");
    } else {
      setFileName("No file chosen");
    }
  }, [initialFile]);

  const MAX_FILE_SIZE = 1 * 1024 * 1024;
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];

    if (file) {
      if (file.size > MAX_FILE_SIZE) {
        toast.error(`"${file.name}" is too large. Max limit is 1MB.`);

        if (event.target) {
          event.target.value = "";
        }

        setFileName("No file chosen");
        return;
      }

      setFileName(file.name);
      if (onFileSelect) onFileSelect(file);
    }
  };

  const [inputProps, setInputProps] = useState<any>({});

  useEffect(() => {
    if (name && register) {
      const registered = register(name, validation);
      setInputProps({
        ...registered,
        onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
          handleFileChange(e); // your custom file logic
          registered.onChange?.(e); // forward to RHF without recursion
        },
      });
    }
  }, [name, register]);

  return (
    <div className="w-full   space-y-1">
      <div
        onClick={() => fileRef.current?.click()}
        className={`flex items-center w-full bg-white p-1 cursor-pointer border ${error ? "border-red-500" : "border-[#E0E0E0]"
          } rounded-full overflow-hidden`}
      >
        <div className="bg-[#FFF5CC] text-[#000] px-4 py-1 flex items-center gap-1 rounded-full border border-[#FBD037]">
          <IconUpload size={16} />
          <span className="text-sm font-medium">Upload</span>
        </div>
        <div className="px-4 text-sm text-[#555] truncate">{fileName}</div>

        <input
          type="file"
          ref={(el) => {
            fileRef.current = el;
            if (inputProps?.ref) inputProps.ref(el);
          }}
          onChange={(e) => {
            handleFileChange(e);
            inputProps?.onChange?.(e); // important!
          }}
          name={inputProps?.name}
          className="hidden"
          accept={accept}
        />
      </div>
      {error?.message && (
        <span className="text-red-500 text-sm min-h-[0.5rem] block pl-3 ">
          {error?.message || ""}
        </span>
      )}
    </div>
  );
};

export default CustomFileInput;
